import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { findPage } from "../../seo/pages";

// Client-side navigation helper: resets scroll and keeps the tab title in sync (SEO tags are pre-rendered).
export default function ScrollManager() {
  const { pathname, hash } = useLocation();
  const firstRender = useRef(true);

  useEffect(() => {
    const page = findPage(pathname);
    if (page) document.title = page.title;
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }
    if (!hash) window.scrollTo(0, 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- `findPage` is a module import, `firstRender` a stable ref and `page` is derived inside the effect
  }, [pathname, hash]);

  return null;
}
